<template>
  <div class="home-wrap">
    <div class="padding-12-15 padding-b-30">
      <div class="title-text">我的推广位</div>
      <div class="desc">推广流程：创建专属推广位->获取推广链接（二维码）->粉丝购票下单->结算推广佣金</div>
    </div>
    <div class="gray"></div>
    <div class="padding-12-15">
      <div class="title-text">我的资产</div>
      <div class="purse-info">
        <div>
          <div class="purse-money">{{account.balance}}</div>
          <div class="purse-title">总收入（元）</div>
        </div>
        <div>
          <div class="purse-money">{{account.waitSettleAmount}}</div>
          <div class="purse-title">待结算（元）</div>
        </div>
        <div>
          <div class="purse-money">{{account.max_withdraw_amount}}</div>
          <div class="purse-title">可提现（元）</div>
        </div>
      </div>
    </div>
    <div class="gray"></div>
    <div class="padding-12-15 padding-b-8">
      <div class="title-text">近30日数据趋势</div>
      <div class="echart-content">
        <div class="echart-dom" id="chartLineBox"></div>
        <div class="echar-desc">
          <div class="detail-item">
            <span class="detail-badge bg-orange"></span>
            <span class="detail-title">点击数:</span>
            <span class="detail-content">{{report.clickNum}}</span>
          </div>
          <div class="detail-item">
            <span class="detail-badge bg-blue"></span>
            <span class="detail-title">预估订单量:</span>
            <span class="detail-content">{{report.validOrderNum}}</span>
          </div>
          <div class="detail-item">
            <span class="detail-badge bg-pink"></span>
            <span class="detail-title">预估收入:</span>
            <span class="detail-content">{{report.validIncome}}</span>
          </div>
        </div>
        <div class="echart-info">
          <p class="font-15">报表说明：</p>
          <p>1.订单数、订单金额、预估佣金更新都可能有延迟，延迟时间在10分钟左右。</p>
          <p>2.本报表显示在指定的时间段内发生的订单状况。</p>
          <p>3.本报表显示的数据非最终确认结算的数据。</p>
        </div>
      </div>
    </div>
    <div class="gray"></div>
    <div class="padding-12-15 padding-b-8">
      <div class="title-text">推广位数据趋势</div>
      <div class="table-wrapper">
        <el-table :data="list" border style="width: 100%">
          <el-table-column prop="date" label="推广位名称" width="100">
            <template slot-scope="{row}">
              <span>{{ row.app_name }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="AppKey" width="100">
            <template slot-scope="{row}">
              <span>{{ row.app_key }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="30日点击数" width="100">
            <template slot-scope="{row}">
              <span>{{ row.clickNum }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="30日订单" width="90">
            <template slot-scope="{row}">
              <span>{{ row.validOrderNum }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="30日预估收入" width="110">
            <template slot-scope="{row}">
              <span>{{ row.validIncome }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="90" class-name="text-center">
            <template slot-scope="{row}">
              <el-button @click="toReport(row)" type="text" size="small" style="color: #FF4F76;">查看报表</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :page.sync="searchForm.page" :limit.sync="searchForm.pagesize" @pagination="getList" />
      </div>
    </div>
  </div>
</template>

<script>
  import echarts from 'echarts'
  import Pagination from '@/components/Pagination' // secondary package based on el-pagination
  import { index,getIndexAppList } from '@/api/promotion'
  export default {
    name: 'PromotionHome',
    components: {
      Pagination
    },
    data () {
      return {
        chartLine: undefined,
        account:[],
        report:{
          dayList:[],
          clickNum:0,
          validIncome:0,
          validOrderNum:0,
          clickNumList:[],
          validIncomeList:[],
          validOrderNumList:[],
        },
        list: [],
        listLoading: false,
        total:0,
        searchForm:{
          page: 1,
          pagesize: 10,
        },
      }
    },
    mounted: function () {
      this.initData()
      this.getList(true)
      this.listLoading = true
      this.listLoading = false
    },
    methods: {
      initData(){
        index().then(response => {
          this.report = response.data.appReport
          this.account = response.data.account
          this.listLoading = false
          this.initEchart();
        })
      },
      initEchart: function () {
        if(this.report.dayList.length == 0){
          this.report.dayList = ['暂无数据']
        }

        if(this.report.clickNumList.length == 0){
          this.report.clickNumList= [0];
        }

        if(this.report.validOrderNumList.length == 0){
          this.report.validOrderNumList= [0];
        }
        if(this.report.validOrderNumList.length == 0){
          this.report.validOrderNumList= [0];
        }
        this.chartLine = echarts.init(document.getElementById('chartLineBox'))
        // 指定图表的配置项和数据
        var option = {
          tooltip: {              //设置tip提示
            trigger: 'axis'
          },

          legend: {               //设置区分（哪条线属于什么）
            data: ['点击数', '预估订单量', '预估收入']
          },
          color: ['#3D9EFC', '#FF8622', '#FF4F76'],       //设置区分（每条线是什么颜色，和 legend 一一对应）
          xAxis: {                //设置x轴
            type: 'category',
            boundaryGap: false,     //坐标轴两边不留白
            data: this.report.dayList,
            name: '',           //X轴 name
            nameTextStyle: {        //坐标轴名称的文字样式
              color: '#FA6F53',
              fontSize: 16,
              padding: [0, 0, 0, 20]
            },
            axisLine: {             //坐标轴轴线相关设置。
              lineStyle: {
                color: '#FA6F53',
              }
            }
          },
          yAxis: {
            name: '',
            nameTextStyle: {
              color: '#FA6F53',
              fontSize: 16,
              padding: [0, 0, 10, 0]
            },
            axisLine: {
              lineStyle: {
                color: '#FA6F53',
              }
            },
            type: 'value'
          },
          series: [
            {
              name: '预估订单量',
              data: this.report.validOrderNumList,
              type: 'line',               // 类型为折线图
              lineStyle: {                // 线条样式 => 必须使用normal属性
                normal: {
                  color: '#3D9EFC',
                }
              },
            },
            {
              name: '点击数',
              data: this.report.clickNumList,
              type: 'line',
              lineStyle: {
                normal: {
                  color: '#FF8622',
                }
              },
            },
            {
              name: '预估收入',
              data: this.report.validOrderNumList,
              type: 'line',
              lineStyle: {
                normal: {
                  color: '#FF4F76',
                }
              },
            }
          ]
        };

        // 使用刚指定的配置项和数据显示图表。
        this.chartLine.setOption(option);
      },
      //推广位列表
      getList(first = false){
        this.listLoading = true
        if(first) this.searchForm.page = 1
        getIndexAppList().then((response) => {
          this.listLoading = false
          if(response.code != 200){
            this.$toast.fail(response.msg)
            return
          }
          this.list = response.data.list
          this.total = response.data.total
        }).catch(() => {
          this.listLoading = false
        })
      },

      //查看推广位
      toReport(row){
        this.$store.dispatch('h_nav/changePromotionActiveIndex',2)
        this.$router.push({ path: '/h5/promotion/report', query: { app_key: row.app_key }})
      },
    }
  }
</script>

<style lang="less" scoped>
  .home-wrap{
    font-family: Alibaba-PuHuiTi-R;
    .purse-info{
      background-image: url(../../../../assets/img/h5/promote_bg.png);
      background-repeat: no-repeat;
      background-size: cover;
      background-position: 50% 50%;
      width: 100%;
      height: 80px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-around;
      color: #FFFFFF;
      text-align: center;
      margin: 8px 0;
      .purse-money{
        font-size: 16px;
        font-family: Alibaba-PuHuiTi-M;
        padding-bottom: 3px;
      }
      .purse-title{
        opacity: 0.8;
        font-size: 13px;
      }
    }
    .echart-content {
      border: 1px solid #EEEEEE;
      border-radius: 4px;
      width: 100%;
      .echart-dom {
        height: 242px;
        margin: 0 auto;
        padding: 15px 8px;
      }
      .echar-desc {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding: 0 8px;
        .detail-item {
          margin-right: 12px;
          .detail-badge {
            border-radius: 100%;
            -webkit-box-shadow: 0 0 0 1px #fff;
            box-shadow: 0 0 0 1px #fff;
            width: 8px;
            height: 8px;
            display: inline-block;
            position: relative;
            top: -1px;
            margin-right: 10px;
          }
          .detail-title {
            font-size: 14px;
            color: #666666;
            line-height: 20px;
            padding-right: 10px;
          }
          .detail-content {
            font-size: 14px;
            color: #333333;
            line-height: 20px;
          }
        }
      }
      .echart-info {
        padding: 8px;
        color: #999999;
        .font-15{
          font-size: 15px;
        }
      }
      .bg-orange {
        background: #ff8622;
      }
      .bg-blue {
        background: #3d9efc;
      }
      .bg-pink {
        background: #ff4f76;
      }
    }
    .table-wrapper {
      width: 100%;
      margin-top: 8px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/h5/promotion/home/Index.vue